import { useMutation } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'

type ProcessEvidenceForMaiaVariables = {
    evidenceId: string
}

type UseProcessEvidenceForMaiaMutationProps = {
    onSuccess?: () => void
    onError?: (error: unknown) => void
}

export const useProcessEvidenceForMaiaMutation = ({
    onSuccess,
    onError,
}: UseProcessEvidenceForMaiaMutationProps = {}) => {
    const { getTokenSilently } = useAuth0()

    const processEvidence = async ({ evidenceId }: ProcessEvidenceForMaiaVariables): Promise<void> => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        await callAPI(endpoints.processEvidenceForMaia.url, endpoints.processEvidenceForMaia.method, token, {
            evidenceId,
        })
    }

    return useMutation(processEvidence, {
        onSuccess: () => onSuccess?.(),
        onError: (error) => {
            console.error('[useProcessEvidenceForMaiaMutation] Failed:', error)
            onError?.(error)
        },
    })
}
